package one.healthium.log_food.ui.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.value.Value
import one.healthium.log_food.ui.navigation.find_food.FindFoodComponent
import one.healthium.log_food.ui.navigation.scan_results.ScanResultsComponent
import one.healthium.profile.ui.food.models.FoodUiModel

interface LogFoodComponent : ViewModelStoreOwner {

    val stack: Value<ChildStack<*, Child>>
    val taskId: String?
    val food: FoodUiModel?

    fun onCloseClicked()

    sealed class Child {
        class FindFood(val component: FindFoodComponent) : Child()
        class ScanResults(val component: ScanResultsComponent) : Child()
    }
}
